import { CommunityCard } from "../components/CommunityCard";
import { useT } from "../i18n";

export function CommunityPage() {
  const tr = useT();
  return (
    <div>
      <div className="page-head">
        <div>
          <div className="eyebrow" style={{ marginBottom: 8 }}>Communauté</div>
          <h1>{tr("Communauté")}</h1>
          <div className="sub">{tr("Rejoins les makers 3DPrintForge — entraide, idées et partages.")}</div>
        </div>
      </div>

      <CommunityCard />
    </div>
  );
}
